/**
 * Confirm a supervisor-proposed schedule (SCH.3 — requested → proposed →
 * confirmed). Shown to the PM (the request owner) — and to a supervisor/admin
 * who can confirm on their behalf — when a project carries a proposed_schedule
 * awaiting confirmation. Confirming commits it: the project becomes scheduled,
 * task times seed, and the dates lock in.
 */
import { CalendarCheck2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useConfirmSchedule } from '@/api/projects';
import { Button } from '@/components/ui/Button';

export function ConfirmScheduleButton({
  projectId,
  title,
}: {
  projectId: string;
  title: string;
}) {
  const confirm = useConfirmSchedule(projectId);
  return (
    <Button
      size="sm"
      onClick={() =>
        confirm.mutate(undefined, {
          onSuccess: () => toast.success(`"${title}" confirmed & scheduled`),
          onError: (err) => toast.error(`Confirm failed: ${err.message}`),
        })
      }
      disabled={confirm.isPending}
    >
      {confirm.isPending ? (
        <Loader2 className="w-3.5 h-3.5 animate-spin" />
      ) : (
        <CalendarCheck2 className="w-3.5 h-3.5" />
      )}
      Confirm dates
    </Button>
  );
}
